'use client';

import { c as _c } from "react/compiler-runtime";
import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { useEffect } from 'react';
type BugsnagBrowserClientProps = {
  apiKey?: string;
  appType: string;
  appVersion: string;
  releaseStage: string;
  enabledReleaseStages: string[];
};
type BugsnagPerformanceClientProps = {
  apiKey?: string;
  appVersion: string;
  releaseStage: string;
  enabledReleaseStages: string[];
};

/**
 * Initializes Bugsnag in browser.
 *
 * @see https://docs.bugsnag.com/platforms/javascript/configuration-options/#available-options
 */
export function BugsnagBrowserClient(t0) {
  const $ = _c(7);
  const {
    appType,
    apiKey,
    appVersion,
    releaseStage,
    enabledReleaseStages
  } = t0;
  let t1;
  if ($[0] !== apiKey || $[1] !== appType || $[2] !== appVersion || $[3] !== enabledReleaseStages || $[4] !== releaseStage) {
    t1 = () => {
      if (!apiKey) {
        return;
      }
      const client = Bugsnag.start({
        appType,
        apiKey,
        appVersion,
        releaseStage,
        enabledReleaseStages,
        plugins: [new BugsnagPluginReact()]
      });
      client.leaveBreadcrumb("Application has started. (Client)");
    };
    $[0] = apiKey;
    $[1] = appType;
    $[2] = appVersion;
    $[3] = enabledReleaseStages;
    $[4] = releaseStage;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  return null;
}

/**
 * Initializes Bugsnag performance monitoring
 */
export function BugsnagPerformanceClient(t0) {
  const $ = _c(6);
  const {
    apiKey,
    appVersion,
    releaseStage,
    enabledReleaseStages
  } = t0;
  let t1;
  if ($[0] !== apiKey || $[1] !== appVersion || $[2] !== enabledReleaseStages || $[3] !== releaseStage) {
    t1 = () => {
      if (!apiKey) {
        return;
      }
      BugsnagPerformance.start({
        apiKey,
        appVersion,
        releaseStage,
        enabledReleaseStages
      });
    };
    $[0] = apiKey;
    $[1] = appVersion;
    $[2] = enabledReleaseStages;
    $[3] = releaseStage;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  useEffect(t1, t2);
  return null;
}